<script setup>
import { Modal } from 'bootstrap';
import { onMounted, ref } from 'vue';
import ModalInstrucciones from "../ModalInstrucciones.vue";

const modalImagenInstrucciones = ref(null);
const imagenSeleccionada = ref(null);

const baseUrl = process.env.VUE_APP_SISTEMA_SUBASTAS_ACTUAL_URL

onMounted(() => {
  modalImagenInstrucciones.value = new Modal(
    document.getElementById("instruccionesModal"),
    { backdrop: "static", keyboard: false }
  );
});

const abrirModalInstruccion = (imagen_id) => {
  switch (imagen_id) {
    case 1:
      imagenSeleccionada.value = "con_martillero_crear_cuenta.png";
      break;
    case 2:
      imagenSeleccionada.value = "con_martillero_credito_disponible.png";
      break;
    case 3:
      imagenSeleccionada.value = "con_martillero_informar_garantia.png";
      break;
    case 4:
      imagenSeleccionada.value = "con_martillero_ficha_subasta.png";
      break;
    default:
      return;
  }

  modalImagenInstrucciones.value.show();
};
const closeModal = () => {
  modalImagenInstrucciones.value.hide();
  imagenSeleccionada.value = null;
};

</script>
<template>
  <div class="container_instrucciones bg_white">
    <div class="block_container">
      <div class="bloque columna_48">
        <div class="columna_flex">
          <img
            class="img_flex"
            src="@/assets/img/illustrations/con_martillero1.png"
          />
        </div>
      </div>
      <div class="bloque columna_52 blue_bg_block">
        <div class="columna_flex">
          <h3 class="texto_blanco titulo_instruccion">1. Creá una cuenta</h3>
          <p class="texto_blanco texto_instrucciones">
            <span class="fw-bold" >Completá el formulario</span> básico de registro. Podés hacerlo a tu nombre
            o a nombre de una empresa.
          </p>
          <p class="texto_blanco texto_instrucciones" @click="abrirModalInstruccion(1)"><span class="fw-bold">¿Cómo hacerlo?<img
              class="ms-2 plus_icon"
              src="@/assets/img/illustrations/plus_white.png"
            /></span></p>
                    <a :href="`${baseUrl}/registro`">
                      <button class="btn btn-light boton_cta texto_blue fs-6" style="font-family: 'Roboto' ">Registrate Ahora</button>
                    </a>
                    </div>
      </div>
    </div>
    <div class="block_container bg_grey">
      <div class="bloque columna_48">
        <div class="columna_flex">
             <img
            class="half_heigth img_flex"
            src="@/assets/img/illustrations/con_martillero2.png"
          />
          <h3 class="titulo_instruccion texto_blue">2. Crédito disponible</h3>
          <p class="texto_instrucciones">
            Ingresá a tu perfil, y en el menú de inicio hacé click en el
            botón: <span class="fw-bold">crédito disponible</span>.
          </p>
          <p class="texto_instrucciones">Ahí vas a encontrar la tabla de créditos. Según el monto de tu garantía, <span class="fw-bold">dispondrás de un crédito máximo para ofertar.</span></p>
          <p class="texto_instrucciones texto_blue fw-bold" @click="abrirModalInstruccion(2)">¿Cómo hacerlo?<img class="ms-2 plus_icon" src="@/assets/img/illustrations/plus_blue.png"/></p>
        </div>
      </div>
      <div class="bloque columna_52">
        <div class="columna_flex">
             <img
            class="img_flex half_heigth"
            src="@/assets/img/illustrations/con_martillero3.png"
          />
          <h3 class="titulo_instruccion texto_blue">3. Informá la garantía </h3>
          <p class="texto_instrucciones">
          <span class="fw-bold">Una vez que hayas realizado el pago </span> (podés hacerlo por echeq, depósito o transferencia bancaria) hacé click en el botón <span class="fw-bold">informar garantía</span>.
          </p>
          <p class="texto_instrucciones">Completá el formulario con los <span class="fw-bold">datos de la transacción, ¡y listo!</span></p>
          <p class="texto_instrucciones texto_blue fw-bold" @click="abrirModalInstruccion(3)">¿Cómo hacerlo?
          <img class="ms-2 plus_icon" src="@/assets/img/illustrations/plus_blue.png"/></p>
        </div>
      </div>
    </div>
    <div class="block_container">
      <div class="bloque columna_52 blue_bg_block">
        <div class="columna_flex">
          <h3 class="texto_blanco texto_instrucciones">4. Ingresá a la ficha de la subasta</h3>
          <p class="texto_blanco texto_instrucciones">Una vez que obtengas el crédito, estás <span class="fw-bold">listo para ofertar </span>. Ingresá a la sala de subastas!
            <span class="fw-bold">¡Buena suerte!</span></p>
          <p class="texto_instrucciones texto_blanco" @click="abrirModalInstruccion(4)">¿Cómo hacerlo?<img
              class="ms-2 plus_icon"
              src="@/assets/img/illustrations/plus_white.png"
            /></p>
        </div>
      </div>
      <div class="bloque columna_48">
        <div class="columna_flex w-100">
          <img
            class="img_flex"
            src="@/assets/img/illustrations/con_martillero4.png"
          />
        </div>
      </div>
    </div>
    <div class="block_container bg_grey ">
      <div class="bloque columna_52 ">
        <div class="columna_flex">
             <img
            class="half_heigth img_flex"
            src="@/assets/img/illustrations/con_martillero5.png"
          />
          <h3 class="titulo_instruccion texto_blue">5. Aprobación (de compra)</h3>
          <p class="texto_instrucciones">
            Una vez finalizada la subasta, recibirás un mail con el <span class="fw-bold">estado de aprobación de los lotes ofertados.</span>
          </p>
        </div>
      </div>
      <div class="bloque columna_48">
        <div class="columna_flex">
             <img
            class="img_flex half_heigth"
            src="@/assets/img/illustrations/con_martillero6.png"
          />
          <h3  class="titulo_instruccion texto_blue">6. Aboná tu compra</h3>
          <p  class="texto_instrucciones">
          Luego de que los lotes sean aprobados, el personal de cobranzas se pondrá en contacto para <span class="fw-bold">realizar el pago y facturación.</span>
          </p>
        </div>
      </div>
    </div>
    <div class="block_container">
      <div class="bloque columna_48">
        <div class="columna_flex">
          <img
            class="img_flex"
            src="@/assets/img/illustrations/con_martillero7.png"
          />
        </div>
      </div>
      <div class="bloque columna_52 blue_bg_block">
        <div class="columna_flex">
          <h3 class="texto_blanco titulo_instruccion">7. Retirá</h3>
          <p class="texto_blanco texto_instrucciones">
            El retiro de los lotes adquiridos se <span class="fw-bold">coordina entre el vendedor y el comprador.</span> 
          </p>
          <p class="texto_blanco texto_instrucciones">¡Que disfrutes tucompra!</p>
        </div>
      </div>
    </div>
     <div class="block_container bg_grey">
        <div class=" columna_flex_cta w-100 mt-5">
            <h1 class="titulo_instruccion titulo_cta">Comprá en Adrián Mercado Subastas</h1>
            <p class="texto_instrucciones texto_cta"><span class="fw-bold">Completá el formulario</span> básico de registro. Podés hacerlo a tu nombre o a nombre de una empresa.</p>
            <a :href="`${baseUrl}/registro`">
              <button class="btn btn-primary boton_cta" style="font-family: 'Roboto' ">Registrate ahora</button>
            </a>
          </div>
    </div>
    <ModalInstrucciones
      :rutaImagen="imagenSeleccionada"
      @closeModal="closeModal"
    />
</div>
</template>
<style lang="scss" scoped>
.plus_icon{
    scale: 0.5;
}
.columna_52 {
    max-width: 52%;
    min-width: 52%;
}
.columna_48 {
    max-width: 48%;
    min-width: 48%;
}
.block_container {
    width: 100%;
    display: flex;
    flex-direction: row;
}
.columna_flex_cta {
    display: flex !important;
    flex-direction: column;
    justify-content: center;
    max-width: 100%;
    padding: 0% 20% !important;
    min-height: 100%;
    font-family: "Roboto Slab";
    margin-left: auto;
    margin-right: auto;
}
.columna_flex {
    display: flex !important;
    flex-direction: column;
    justify-content: center;
    max-width: 400px;
    min-height: 100%;
    font-family: "Roboto Slab";
    margin-left: auto;
    margin-right: auto;
}
.half_heigth {
    max-height: 240px;
}
.bg_grey{
    background-color:#F6F8F9 !important;
}

.img_flex{
    object-fit: contain;
}
.bloque,
.block_container {
    min-height: 600px;
}
.texto_blue {
    color: #375dbf !important;
}
.blue_bg_block {
    background-color: #375dbf !important;
}
.texto_blanco {
    color: white !important;
}
.titulo_instruccion{
    font-size: xx-large !important;
}
.texto_instrucciones{
    font-size: larger !important;
}
.titulo_cta{
    color: #375dbf !important;
    font-size:xx-large !important;
}
.texto_cta{
    font-size: large !important;
}
.bg_white{
    background-color: white !important;
}
.boton_cta{
    border-radius: 0px !important;
    max-width:max-content;
}

@media (max-width: 800px) {
    .texto_instrucciones {
    font-size: x-small !important;
    }
    .titulo_instruccion {
    font-size: large !important;
    }
    .bloque,
    .block_container {
    min-height:450px;
    }

    .columna_flex {
    max-width: 95%;
    }
}

@media (max-width: 500px) {
    .texto_instrucciones {
    font-size: xx-small !important;
    }
    .titulo_instruccion {
    font-size: small !important;  
    }
    .bloque,
    .block_container {
    min-height:300px;
    }
    .columna_flex {
    max-width: 95%;
    }
}

</style>
